import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Analytics16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    data-test="analytics-icon"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M6.41612 2.30308C6.61018 2.10902 6.87338 2 7.14783 2H8.85217C9.12662 2 9.38982 2.10902 9.58388 2.30308C9.77793 2.49714 9.88696 2.76034 9.88696 3.03478V13.0783H10.3739V5.5913C10.3739 5.31686 10.4829 5.05366 10.677 4.8596C10.8711 4.66554 11.1343 4.55652 11.4087 4.55652H13.113C13.3875 4.55652 13.6507 4.66554 13.8447 4.8596C14.0388 5.05366 14.1478 5.31686 14.1478 5.5913V13.0783H14.3913C14.7275 13.0783 15 13.3508 15 13.687C15 14.0231 14.7275 14.2957 14.3913 14.2957H1.6087C1.27252 14.2957 1 14.0231 1 13.687C1 13.3508 1.27252 13.0783 1.6087 13.0783H1.85217V8.14783C1.85217 7.87339 1.9612 7.61018 2.15525 7.41612C2.34931 7.22207 2.61251 7.11304 2.88696 7.11304H4.5913C4.86575 7.11304 5.12895 7.22207 5.32301 7.41612C5.51706 7.61018 5.62609 7.87338 5.62609 8.14783V13.0783H6.11304V3.03478C6.11304 2.76034 6.22207 2.49714 6.41612 2.30308ZM7.33043 13.0783H8.66956V3.21739H7.33043V13.0783ZM4.4087 13.0783V8.33043H3.06957V13.0783H4.4087ZM12.9304 13.0783V5.77391H11.5913V13.0783H12.9304Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
